import { render, staticRenderFns } from "./KimlikBilgileriList.vue?vue&type=template&id=c887aaf8"
import script from "./KimlikBilgileriList.vue?vue&type=script&lang=ts"
export * from "./KimlikBilgileriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports